import React from 'react';
import { Image } from '@noths/polaris-client-ribbons-design-system';

import type { Product } from '../../../../types/dontgiftguide';
import { ProductLabel } from '../../atoms/ProductLabel/ProductLabel';
import * as styles from './SmallProductTile.styles';

export interface SmallProductTileProps {
  onLinkClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  product: Product;
}

export const SmallProductTile = ({ onLinkClick, product }: SmallProductTileProps) => {
  if (!product) {
    return null;
  }

  return (
    <div css={styles.tile}>
      <a href={product.href} onClick={onLinkClick}>
        <Image src={product.image.normal} alt="" loading="lazy" />
        <p css={styles.title}>
          <ProductLabel product={product} />
        </p>
      </a>
    </div>
  );
};
